<template>
  <div class="project-stats">

    <h2>留言统计</h2>

    <div class="stats-header">
      <div class="time-filter">
        <el-select
          v-model="timeRange"
          placeholder="快捷日期"
          style="width: 120px; margin-right: 12px;"
          @change="onTimeRangeChange"
        >
          <el-option label="今天" value="today" />
          <el-option label="昨天" value="yesterday" />
          <el-option label="前天" value="dayBeforeYesterday" />
          <el-option label="自定义" value="custom" />
        </el-select>
        <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期时间"
            end-placeholder="结束日期时间"
            style="width: 320px; margin-right: 12px;"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
        />
        <div class="data-layout">
          <el-button @click="setToday">今天</el-button>
          <el-button @click="prevDay">前一天</el-button>
          <el-button @click="nextDay">后一天</el-button>
        </div>
        <el-button class="bt_layout" type="primary" icon="el-icon-search" @click="queryStats">查询</el-button>
        <el-button class="bt_layout" type="success" icon="el-icon-edit" round @click="goToSetRange">设置项目范围</el-button>
        <el-button class="bt_layout" type="success" icon="el-icon-edit" round @click="goToSetTarget">设置目标数</el-button>
      </div>
    </div>

    <div class="stats-content">
      <div class="stats-table">
        <el-table
          :data="projectStats"
          style="width: 100%"
          empty-text="暂无数据"
          border
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            label="序号"
            align="center"
            width="60"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="项目名称"
            align="center"
            min-width="150"
          />



          <el-table-column
            prop="targetCount"
            :label="isMobile ? `目标（${totalTargetCount}）` : `目标数（${totalTargetCount}）`"
            align="center"
            min-width="100"
          />

          <el-table-column
            prop="messageCount"
            :label="isMobile ? `留言（${totalMessageCount}）` : `留言数量（${totalMessageCount}）`"
            align="center"
            min-width="140"
          />

          <el-table-column
              label="项目范围"
              align="center"
              min-width="300"
          >
            <template slot-scope="scope">
              <span class="project-range-text">
                {{ scope.row.scope }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ProjectStats',
  data() {
    return {
      timeRange: 'today',
      dateRange: [], // [start, end]
      projectStats: [],
      totalTargetCount: 0,
      totalMessageCount: 0,
      isMobile: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date();
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '前天',
            onClick(picker) {
              const start = new Date();
              start.setDate(start.getDate() - 2);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 2);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setDate(start.getDate() - 7);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date();
              start.setFullYear(start.getFullYear() - 1);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
    }
  },
  mounted() {
    this.setQuickDate('today');
    this.checkScreenSize();
    // 确保日期设置完成后再加载数据
    this.$nextTick(() => {
      this.loadProjectStats();
    });

    // 监听窗口大小变化
    window.addEventListener('resize', this.checkScreenSize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },

    setQuickDate(type) {
      const today = new Date();
      let start, end;
      switch (type) {
        case 'today':
          start = new Date(today);
          start.setHours(0, 0, 0, 0);
          end = new Date(today);
          end.setHours(23, 59, 59, 999);
          break;
        case 'yesterday':
          start = new Date(today);
          start.setDate(start.getDate() - 1);
          start.setHours(0, 0, 0, 0);
          end = new Date(today);
          end.setDate(end.getDate() - 1);
          end.setHours(23, 59, 59, 999);
          break;
        case 'dayBeforeYesterday':
          start = new Date(today);
          start.setDate(start.getDate() - 2);
          start.setHours(0, 0, 0, 0);
          end = new Date(today);
          end.setDate(end.getDate() - 2);
          end.setHours(23, 59, 59, 999);
          break;
        default:
          start = '';
          end = '';
      }
      if (start && end) {
        this.dateRange = [
          this.formatDateTime(start),
          this.formatDateTime(end)
        ];
      } else {
        this.dateRange = [];
      }
    },
    formatDateTime(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    onTimeRangeChange(val) {
      if (val === 'custom') {
        this.dateRange = [];
      } else {
        this.setQuickDate(val);
      }
    },
    queryStats() {
      this.loadProjectStats();
    },
    async loadProjectStats() {
      let startDate, endDate;
      if (this.timeRange === 'custom') {
        if (!this.dateRange || this.dateRange.length !== 2) {
          this.$message.warning('请选择自定义时间范围');
          return;
        }
        startDate = this.dateRange[0];
        endDate = this.dateRange[1];
      } else {
        startDate = this.dateRange[0];
        endDate = this.dateRange[1];
      }

      if (!startDate || !endDate) {
        this.$message.warning('请选择时间范围');
        return;
      }

      const requestData = {
        startDate: startDate ? startDate.replace(/\s/g, 'T') : '',
        endDate: endDate ? endDate.replace(/\s/g, 'T') : ''
      };

      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        const authority = userInfo.authority;
        const employeeId = userInfo.employeeId;

        let url;
        if (authority == 1) {
          url = `/api/messages/countByTimeRangeWithOrder`;
        } else {
          url = `/api/messages/countByTimeRangeWithOrderAndEmployee?employeeId=${employeeId}`;
        }

        const response = await axios.post(url, requestData);
        if (response.data.success) {
          this.projectStats = [...response.data.data]
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((item, index) => ({
              id: index + 1,
              name: item.projectName || '未知项目',
              scope: item.scope || "",
              messageCount: item.messageCount || 0,
              targetCount: item.targetCount || 0
            }));
          console.log(this.projectStats);
          this.calculateTotals();
        } else {
          this.projectStats = [];
          this.totalTargetCount = 0;
          this.totalMessageCount = 0;
          this.$message.error('获取项目统计失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        this.projectStats = [];
        this.totalTargetCount = 0;
        this.totalMessageCount = 0;
        this.$message.error('获取项目统计失败: ' + error);
      }
    },
    calculateTotals() {
      this.totalTargetCount = this.projectStats.reduce((sum, item) => sum + (item.targetCount || 0), 0);
      this.totalMessageCount = this.projectStats.reduce((sum, item) => sum + (item.messageCount || 0), 0);
    },
    goToSetTarget() {
      this.$router.push({ name: 'ProjectTarget' });
    },
    goToSetRange() {
      this.$router.push({ name: 'ProjectRange' });
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 4 === 3) {
        return 'even-row';
      }
      return '';
    },
    setToday () {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let start, end;
      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;
      start = format(today);
      end = endFormat(today);
      this.dateRange = [start, end];
    },
    prevDay () {
      let startDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[0])
          : new Date(); // 如果没选过，默认今天
      let endDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[1])
          : new Date(); // 如果没选过，默认今天

      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;

      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1);
      const start = format(startDate);
      const end = endFormat(endDate);
      this.dateRange = [start, end];
    },
    nextDay () {
      let startDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[0])
          : new Date(); // 如果没选过，默认今天
      let endDate = this.dateRange && this.dateRange.length > 0
          ? new Date(this.dateRange[1])
          : new Date(); // 如果没选过，默认今天

      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;

      startDate.setDate(startDate.getDate() + 1);
      endDate.setDate(endDate.getDate() + 1);
      const start = format(startDate);
      const end = endFormat(endDate);
      this.dateRange = [start, end];
    }
  }
}
</script>

<style scoped>
.project-stats {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 16px;
}

.stats-header {
  padding: 24px 32px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.project-stats h2 {
  margin: 0 0 0 20px;
  font-size: 20px;
  color: #333;
}

.time-filter {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;   /* ✅ 超出宽度自动换行 */
}

.bt_layout {
  white-space: nowrap;  /* ✅ 防止文字换行 */
}

.stats-content {
  padding: 24px 32px;
}

.stats-table {
  /* 桌面端：不设置横向滚动，自动适应宽度 */
}

/* 移动端：设置横向滚动 */
@media (max-width: 768px) {
  /* 头部样式优化 */
  .stats-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px 20px;
  }

  .project-stats {
    padding: 16px;
  }

  .project-stats h2 {
    text-align: center;
    margin: 0;
    font-size: 18px;
  }

  /* 时间筛选器优化 */
  .time-filter {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .time-filter .el-select {
    width: 100% !important;
  }

  .time-filter .el-date-editor {
    width: 100% !important;
  }

  .time-filter .el-button {
    width: 100%;
  }

  .time-filter .bt_layout {
    margin: 0;
  }

  /* 内容区域优化 */
  .stats-content {
    padding: 16px 20px;
  }

  /* 表格横向滚动 */
  .stats-table {
    overflow-x: auto;
    white-space: nowrap;
  }

  .stats-table .el-table {
    min-width: 900px;
  }

  .stats-table th,
  .stats-table td {
    white-space: nowrap;
  }

  /* 时间选择器弹窗优化 */
  .el-date-editor.el-input {
    width: 100% !important;
  }

  .el-date-editor .el-range-input,
  .el-date-editor .el-range-separator {
    font-size: 12px;
  }

  .el-picker-panel {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    max-width: 90vw !important;
    max-height: 80vh !important;
    overflow: auto !important;
    z-index: 9999 !important;
  }

  .el-date-range-picker {
    width: auto !important;
    min-width: 280px !important;
    max-width: 90vw !important;
  }

  .el-date-range-picker .el-picker-panel__content,
  .el-date-range-picker .el-date-range-picker__content,
  .el-date-range-picker .el-date-range-picker__body {
    width: auto !important;
    min-width: 280px !important;
  }

  .el-date-range-picker .el-date-range-picker__body {
    min-width: 280px !important;
  }
}
/deep/ .el-table .even-row {
  background-color:rgb(177, 238, 147) !important;
}
/deep/ .el-table .even-row td {
  background-color:rgb(177, 238, 147) !important;
}

+/deep/ .el-table {
  border: 2px solid #dcdfe6;
}
+/deep/ .el-table th {
  border: 1px solid #dcdfe6;
  background-color: #f5f7fa;
}
+/deep/ .el-table td {
  border: 1px solid #dcdfe6;
}
+/deep/ .el-table--border th,
+/deep/ .el-table--border td {
  border-right: 1px solid #dcdfe6;
}

/*
.project-range-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 580px;
}
*/


/*.project-range-text {
  display: inline-block;
  max-width: 550px;     !* 限制列宽度 *!
  white-space: nowrap;  !* 不换行 *!
  overflow: hidden;     !* 超出隐藏 *!
  text-overflow: ellipsis; !* 显示省略号 *!
  vertical-align: middle;
}*/

/*
.project-range-text {
  display: inline-block;
  max-width: 550px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer; !* 鼠标变小手，提示可点击 *!
  vertical-align: middle;
}
*/

.project-range-text {
  display: block;          /* 占一整行，支持换行 */
  white-space: normal;     /* 允许换行 */
  word-break: break-word;  /* 单词或文字超出换行 */
  color: #333;             /* 字体颜色 */
  line-height: 1.5;        /* 行高，可读性更好 */
}

/* 桌面端：移除最大宽度限制，让内容自适应 */
@media (min-width: 769px) {
  .project-range-text {
    max-width: none;
  }
}

/* 移动端：保持最大宽度限制 */
@media (max-width: 768px) {
  .project-range-text {
    max-width: 550px;
  }
}


.project-range-text:hover {
  color: #ff0000;            /* 鼠标悬停时变红 */

  font-weight: bold;         /* 加粗文字 */
  /*border-radius: 3px;
  background-color: #fff7b1;
  padding: 2px 6px;*/
}

/* tooltip 弹出文字变红 */
.red-tooltip {
  color: red;
  font-weight: bold; /* 或 bold，根据需求 */
}

.my-slide-fade-enter-active,
.my-slide-fade-leave-active {
  transition: all 0.3s ease;
}
.my-slide-fade-enter {
  opacity: 0;
  transform: translateY(10px); /* 初始下移 */
}
.my-slide-fade-leave-to {
  opacity: 0;
  transform: translateY(10px); /* 消失下移 */
}

/* 默认隐藏 */
.data-layout {
  display: none;
}

/* 屏幕宽度小于768px时（手机、微信内置浏览器常见宽度）显示 */
@media screen and (max-width: 768px) {
  .data-layout {
    display: flex;
  }

  .data-layout .el-button {
    width: 100%;
    justify-content: center;
  }

}

.data {
  display: none;
}
</style>